import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {Payday} from "../Payday";
import {gsap} from "gsap";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {
    SimplePresentation,
    SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {FreeSpinsRestoreIntro} from "../runnerpresentations/freespin/FreesSpinIntro";
import {LocalPresentation} from "../runnerpresentations/LocalPresentation";
import {ResetClaws} from "../runnerpresentations/ResetClaws";

export class PaydayIdleFreespinsPresentation implements FlowStatePresentation {

    presentations:SimplePresentation[] = [
        new FreeSpinsRestoreIntro(),

        new LocalPresentation(
            (controller:SimplePresentationRunnerController) => {
                const tl = gsap.timeline();
                tl.add(gsap.to(this, {duration: 0.5}));
                tl.add(() => controller.finish());
            },
            () => Payday.model.isRestore && Payday.model.data.mode == GameMode.FREESPIN,
            "Retore Padding"),

        new ResetClaws(),

        new LocalPresentation(
            (controller:SimplePresentationRunnerController) => this.spin(controller),
            () => true,
            "Freespin Spin")
    ];

    constructor() {}

    public start(flowStateController:FlowStateController) {
        SimplePresentationRunner.run(this.presentations, () => flowStateController.finish(), (callback?:Function) => flowStateController.setSkipCallback(callback), "FreespinIdle ");
    }

    spin(controller:SimplePresentationRunnerController) {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            Payday.keypadPlugin.setZeroBetSpinCounter(Payday.model.data.freespinsLeft - 1);
            Payday.apiPlugin.betHandler.zeroBet();
            const sounds = ["reelsSpinning", "reelsSpinning2", "reelsSpinning3"]
            const index = Math.floor(Math.random() * 3);
            Payday.soundPlayer.playLoopingSound(sounds[index]);
        })
        tl.add(Payday.reelView.startConveyorBelts())
        tl.add(Payday.reelView.reel.start(), '<');

        // padding here to make action spins not shit itself from reel start going too fast
        // seems to be at least around 0.3s for most other games but here it was effectively 0
        // 0.3 seems to have worked but having 0.35 gives us some margins to work with
        tl.add(() => { controller.finish() }, '>0.35');
    }
}